export interface DeliveryNoteConfig {
  showKilometerInput: boolean;
  autofocusKilometers: boolean;
  showReturnNoteScanOption: boolean;
  openDialogMaxMenge?: boolean;
}
